/**
 * Custom JavaScript for Newsletter Reminder Mobile Functionality
 * Handles tap-to-expand behavior on mobile devices
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    const reminder = document.querySelector('newsletter-reminder');

    if (!reminder) return;

    // Mobile tap-to-expand functionality
    function handleMobileTap() {
      if (window.innerWidth <= 768) {
        // Add click listener for mobile
        reminder.addEventListener('click', function(e) {
          // If not expanded yet, expand it and prevent popup trigger
          if (!reminder.classList.contains('expanded')) {
            e.preventDefault();
            e.stopPropagation();
            reminder.classList.add('expanded');
          }
          // If already expanded, let the original click handler work (opens popup)
        });

        // Close when clicking outside
        document.addEventListener('click', function(e) {
          if (reminder.classList.contains('expanded') && !reminder.contains(e.target)) {
            reminder.classList.remove('expanded');
          }
        });

        // Close on escape key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && reminder.classList.contains('expanded')) {
            reminder.classList.remove('expanded');
          }
        });
      }
    }

    // Initialize on load
    handleMobileTap();

    // Re-initialize on resize (with debounce)
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Remove expanded class if switching to desktop
        if (window.innerWidth > 768) {
          reminder.classList.remove('expanded');
        }
      }, 250);
    });
  });
})();

/**
 * Responsive Thumbnail Position
 * Updates data-position attribute and Flickity childNavVertical arg based on screen size
 */

(function() {
  'use strict';

  function updateThumbnailPosition() {
    const thumbs = document.querySelector('[data-product-thumbs]');
    if (!thumbs) return;

    const isMobile = window.matchMedia('(max-width: 728px)').matches;
    const desktopPos = thumbs.dataset.positionDesktop || 'beside';
    const mobilePos = thumbs.dataset.positionMobile || 'below';
    const shouldBeVertical = isMobile ? (mobilePos === 'beside') : (desktopPos === 'beside');

    // Update data-position for fallback
    thumbs.dataset.position = isMobile ? mobilePos : desktopPos;

    // Find the Product section instance and update its flickity args
    const productContainer = thumbs.closest('[data-section-id]');
    if (productContainer) {
      const sectionId = productContainer.getAttribute('data-section-id');

      // Find the Product instance in theme.sections.instances
      if (theme && theme.sections && theme.sections.instances) {
        const productInstance = theme.sections.instances.find(function(instance) {
          return instance.id === sectionId;
        });

        if (productInstance && productInstance.flickity && productInstance.flickity.args) {
          productInstance.flickity.args.childVertical = shouldBeVertical;
        }
      }
    }
  }

  // Run immediately in case the DOM is already loaded
  updateThumbnailPosition();

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    updateThumbnailPosition();

    // Also run after a delay to ensure Flickity is fully initialized
    setTimeout(updateThumbnailPosition, 100);
  });

  // Run on resize (with debounce for performance)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateThumbnailPosition, 100);
  });
})();
